import { useTranslation } from 'react-i18next'

import Button from 'js/components/Button'
import { CardContent } from 'js/components/Card'
import Flexer from 'js/components/Flexer/Flexer'

import { WidgetOptions } from '../WidgetSettings'

export type ActionsElementProps = {
    onClose: () => void
    handleSave: () => void
    widgetOptions: WidgetOptions
}

export const ActionsElement = ({
    onClose,
    handleSave,
    widgetOptions = {},
}: ActionsElementProps) => {
    const { t } = useTranslation()

    const { saveButton } = widgetOptions

    return (
        <CardContent>
            <Flexer>
                <Button
                    size="normal"
                    variant="tertiary"
                    type="button"
                    onClick={onClose}
                    data-testid="button-cancel"
                >
                    {t('action.cancel')}
                </Button>
                <Button
                    size="normal"
                    variant="primary"
                    onHandle={handleSave}
                    disabled={saveButton.disabled}
                    data-testid="button-save"
                >
                    {t('action.save')}
                </Button>
            </Flexer>
        </CardContent>
    )
}

export default ActionsElement
